import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';

const Questionnaire = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [questionnaireData, setQuestionnaireData] = useState(null);
  const [entryTypeData, setEntryTypeData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const PAGE_SIZE = 5;

  const [values, setValues] = useState({
    questionnaire_id: null,
    questionnaire_name: '',
    entry_type_1: '',
    entry_type_2: '',
    entry_type_3: '',
    entry_type_4: '',
    entry_type_5: '',
    entry_type_6: '',
    entry_type_7: '',
    entry_type_8: '',
    entry_type_9: '',
    entry_type_10: ''
  });

  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const questionnaireData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/questionnaire/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setQuestionnaireData(questionnaireData);

    var reg_params = { site_id: siteId, mall_id: mallId };
    const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/entry_type/search/`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data;
    result.sort((a, b) => a.entry_type < b.entry_type ? -1 : 1);
    setEntryTypeData(result);

  }, [siteId, mallId]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      ticket_id: null,
      questionnaire_name: '',
      entry_type_1: '',
      entry_type_2: '',
      entry_type_3: '',
      entry_type_4: '',
      entry_type_5: '',
      entry_type_6: '',
      entry_type_7: '',
      entry_type_8: '',
      entry_type_9: '',
      entry_type_10: ''
    });
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.questionnaire_name) {
      window.alert('アンケート名を入力してください。');
      return;
    }
    if (!data.entry_type_1) {
      window.alert('入力区分を選択してください。');
      return;
    }

    var params = data;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;

    let res;
    try {
      setLockData(true);
      if (params.questionnaire_id === null || params.questionnaire_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/questionnaire/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {

        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/questionnaire/${params.questionnaire_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`アンケート[${data.questionnaire_id}:${data.questionnaire_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      mall_id: mallId,
      questionnaire_id: data.questionnaire_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/questionnaire/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.questionnaire_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.questionnaire_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-60`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }


  const handleChange = (e) => {
    const target = e.target;
    var value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>アンケートID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="questionnaire_id" defaultValue={values.questionnaire_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>アンケート名</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="questionnaire_name" value={values.questionnaire_name} onChange={handleChange} placeholder="アンケート名を入力してください" />
          </div>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_1" className="mb-0">入力区分1</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_1" name="entry_type_1" value={values.entry_type_1 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_2" className="mb-0">入力区分2</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_2" name="entry_type_2" value={values.entry_type_2 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_3" className="mb-0">入力区分3</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_3" name="entry_type_3" value={values.entry_type_3 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_4" className="mb-0">入力区分4</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_4" name="entry_type_4" value={values.entry_type_4 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_5" className="mb-0">入力区分5</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_5" name="entry_type_5" value={values.entry_type_5 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_6" className="mb-0">入力区分6</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_6" name="entry_type_6" value={values.entry_type_6 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_7" className="mb-0">入力区分7</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_7" name="entry_type_7" value={values.entry_type_7 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_8" className="mb-0">入力区分8</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_8" name="entry_type_8" value={values.entry_type_8 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_9" className="mb-0">入力区分9</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_9" name="entry_type_9" value={values.entry_type_9 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto text-center">
          <label htmlFor="entry_type_10" className="mb-0">入力区分10</label>
        </div>
        <div className="col-auto text-center">
          <select className="form-control" id="entry_type_10" name="entry_type_10" value={values.entry_type_10 || ''} onChange={handleChange}>
            <option value="">- 選択 -</option>
            {entryTypeData && entryTypeData.map((entrytype) => (
              <option key={entrytype.entry_type} value={entrytype.entry_type}>
                {entrytype.entry_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-2 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-2 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    const filteredData = questionnaireData.filter(data =>
      !searchKeyword || data.questionnaire_name.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3 p-0">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="アンケート名で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  アンケートID
                </td>
                <td className="text-center align-middle">
                  アンケート名
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {pagedData.map((data) => (
                <tr key={data.questionnaire_id}>
                  {/* アンケートID */}
                  <td className="text-center align-middle">
                    {data.questionnaire_id}
                  </td>
                  {/* アンケート名 */}
                  <td className="text-center align-middle">
                    {data.questionnaire_name}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  return (
    <div className="container">

      {questionnaireData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {questionnaireData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default Questionnaire;